// extracted by mini-css-extract-plugin
export default {"button":"q3upjwonpQbtBX0xrh4J"};